"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_secure_local_storage_1 = __importDefault(require("@gcloud-npm/utils.secure.local-storage"));
const sendToRelogin = (obj) => {
    let locationToGo = null;
    if (obj && obj.locationToGo) {
        ({ locationToGo } = obj);
    }
    if (obj && obj.clearSession) {
        try {
            const secureStorage = new utils_secure_local_storage_1.default();
            secureStorage.removeItem('ts');
        }
        catch (e) {
            console.error(e);
        }
    }
    let defaultUrl2go = window.location.href;
    if (locationToGo) {
        defaultUrl2go = locationToGo;
    }
    const prefixlink = "https://www.movistar.es/particulares/cms/auth/expired/?redirect=";
    const currentLocation = `${encodeURIComponent(defaultUrl2go)}`;
    window.location.href = `${prefixlink}${currentLocation}`;
};
exports.default = sendToRelogin;
//# sourceMappingURL=index.js.map